<app-header></app-header>
<section style="margin-top: 100px; padding: 20px;">
  <div class="container" style="max-width: 900px; margin: auto; text-align: center;">
    <h2 style="font-size: 28px; font-weight: bold; margin-bottom: 20px;">
      {{ data?.title }}
    </h2>
    <div style="margin-bottom: 20px;">
      <img [src]="path + 'slider/' + data.image" alt="Video Thumbnail" style="max-width: 100%; height: auto; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);" />
    </div>
    <p [innerHTML]="paragraph" style="font-size: 16px; color: #444; line-height: 1.6; white-space: pre-line;">
    </p>
    <div *ngIf="data.url" style="margin-top: 30px;">
      <a [href]="data?.url" target="_blank" style="display: inline-block; background-color: #007BFF; color: white; padding: 12px 24px; border-radius: 5px; text-decoration: none; font-weight: bold;">
        Watch Video
      </a>
    </div>
  </div>
</section>
<section style="margin-top: 100px;">
  <app-footer></app-footer>
</section>
